module.exports = __webpack_public_path__ + "img/28.16b2b34b.jpg";